import React from 'react';

import 'jodit';
import 'jodit/build/jodit.min.css';
import JoditEditor from 'jodit-react';

class WYSIWYG extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      content: props.input ? props.input.value : '',
      config: {
        "toolbar": props.config ? false : true,
      }, // all options from https://xdsoft.net/jodit/play.html
    };
  }

  componentWillReceiveProps(nextProps) {
    if (this.state.value !== nextProps.input.value) {
      this.setState({ content: nextProps.input.value });
    }
  }

  updateContent(value) {
    this.setState({ content: value });
    this.props.input.onChange(value);
  }

  render() {
    return (
      <JoditEditor
        value={this.state.content}
        config={this.state.config}
        onChange={this.updateContent.bind(this)}
      />
    );
  }
}

export default WYSIWYG;



// WEBPACK FOOTER //
// ./src/components/forms/redux-form/WYSIWYG.js